{
  "OptionsMenuTitle": "Mostre as opções disponíveis para este sub-relatório de painel.",
  "DashboardDraggableTitle": "Arraste isso para outro relatório neste painel para trocar de lugar.",
  "OptionsMenuRemove": "Remover relatório",
  "OptionsMenuAdd": "Criar novo relatório",
  "OptionsMenuModify": "Modificar relatório",
  "OptionsMenuChange": "Mudar relatório",
  "OptionsMenuChoose": "Escolha o relatório",
  "OptionMenuUpdateReportError": "Ocorreu um erro ao tentar atualizar o relatório do painel.",
  "OptionMenuRemovePermDelete": "Excluir este relatório permanentemente",
  "NAME": "DashboardOptions"
}